import React from "react";
import { Container } from "react-bootstrap";
import "./Eighth.css";
import main1 from "../../../Asset/ai/image-86.png";
import main2 from "../../../Asset/ai/image-2.png";
import logo1 from "../../../Asset/ai/logo1.png";
import logo2 from "../../../Asset/ai/logo2.png";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Card = ({ imageSrc, logoSrc, title, category, type }) => {
  return (
    <div className="card">
      <div className="img-wraper">
        <img src={imageSrc} className="w-100" alt={title} />
      </div>
      <div className="logo-wraper">
        <img src={logoSrc} alt={`${title} logo`} />
      </div>
      <div className="h3-wraper">
        <h3>{title}</h3>
      </div>
      <div className="p-wraper">
        <p>{category}</p>
      </div>
      <div className="last-text-wraper">
        <p>{type}</p>
      </div>
    </div>
  );
};

const Eighth = () => {
  const cardsData = [
    {
      imageSrc: main1,
      logoSrc: logo1,
      title: "AI Ingredients Scanner",
      category: "Health & Fitness",
      type: "Mobile Application",
    },
    {
      imageSrc: main2,
      logoSrc: logo2,
      title: "Resume Analyzer",
      category: "Recruitment Software",
      type: "Web Application",
    },
  ];

  const navigate = useNavigate();

  return (
    <section className="nineth-d2c-section sixth-mobileApp-section eighth-ai-section">
      <Container>
        <div className="text_wrap">
          <h2>
            Proven <strong> Success Stories</strong>
          </h2>
        </div>
        <div className="card-wraper">
          {cardsData.map((card, index) => (
            <Card
              key={index}
              imageSrc={card.imageSrc}
              logoSrc={card.logoSrc}
              title={card.title}
              category={card.category}
              type={card.type}
            />
          ))}
        </div>
        <div className="btn-wraper">
          <p
            onClick={() => {
              navigate("/portfolio");
            }}
            className="btn btn-primary"
          >
            view All <FaArrowRight className="ms-2" />
          </p>
        </div>
      </Container>
    </section>
  );
};

export default Eighth;
